module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_chubu_pc_b6158e37832d6b3edcda762b16665969.png";